/**
 * ミッション環境ビヘイビアで共有する定数。
 *
 * rjf01〜rjf12 に散在していた同一定数（フレーム秒・ワープ到着の持ち上げ・
 * タイマー刻み）を 1 箇所へ集約する。値はいずれも元 Lua（Roblox）の挙動に
 * 由来し、ミッション間で同一でなければならないため共有する。
 */

/**
 * Roblox の引数なし wait() 1 回ぶんの秒数（約 1/30 秒）。
 * 環境ビヘイビアの「1 フレーム」待機に使う。
 */
export const FRAME_SECONDS = 1 / 30

/**
 * ワープ到着時に着地点を上方向へ持ち上げる量（studs）。
 * Lua: 到着先 to.Position + Vector3.new(0,5,0)（地面へのめり込みを避ける）。
 */
export const WARP_ARRIVAL_LIFT = 5

/**
 * ミッションタイマーの 1 刻みの秒数（Lua: wait(1) で毎秒 +1）。
 */
export const TIMER_TICK_SECONDS = 1
